<template>
  <CContainer>
    <CRow class="justify-content-center mt-4 pb-5" style="">
      <CCol sm="12" md="8" lg="7" xl="5" xxl="5" class="pb-5">
        <div
          class="d-flex flex-column align-items-center justify-content-center mb-2 max-w-500 m-auto pb-5"
        >
          <div class="d-flex align-items-center justify-content-center my-4">
            <h1 class="text-center">Pass Times</h1>
            <HelpCenterButton classes="ms-2" content-key="pass_times" />
          </div>

          <div
            v-for="(passTime, key) in passTimes"
            :key="key"
            class="d-flex align-items-center pass-time-row mb-4"
          >
            <div class="pass-times-label">
              {{ passTime.label }}
            </div>
            <div
              class="d-flex align-items-center time-picker-container"
              :class="{ editable: passTime.isEditable }"
              style="position: relative"
            >
              <div
                :style="`background-color:${passTime.color}; color:${passTime.textColor}`"
                class="d-flex align-items-center justify-content-center rounded-circle p-3 ps-sm-3 pass-times-input-icon"
              >
                <i class="flaticon-coloring-tool" />
              </div>
              <CustomTimePicker
                :show-seconds="true"
                :show="passTimes[key].isEditable"
                v-model="form[key]"
                :readonly="!passTime.isEditable"
                :hide-icon="true"
                format="HH:mm:ss"
                picker-time-format="HH:mm:ss"
                classes="pass-times-picker w-100 wider"
                @blur="passTimes[key].isEditable = false"
              />
            </div>
            <div
              v-if="!passTime.isEditable"
              class="d-flex align-items-center edit-btn"
            >
              <i
                class="flaticon-edit ms-2 my-2"
                @click="passTimes[key].isEditable = true"
              />
            </div>
          </div>
          <div v-if="reqResponse.errors">
            <div v-for="(error, key) in reqResponse.errors" :key="key">
              <div class="invalid-feedback">
                {{ error[0] }}
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-4" @click="submit()">
            <CLoadingButton
              :spinner="isLoading"
              :disabled="isLoading"
              :loading="isLoading"
              class="me-2 btn bg-gradient-blue text-white"
            >
              Update
            </CLoadingButton>
          </div>
          <CAlert
            v-if="reqResponse.message && reqResponse.type === 'success'"
            class="mt-4"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex"
import HelpCenterButton from "../HelpCenterButton"

export default {
  name: "PassTimesForm",
  components: { HelpCenterButton },
  data() {
    return {
      isLoading: false,
      form: {
        white_passes_time: "00:05:00",
        min_time: "00:05:00",
        auto_expire_time: "00:05:00",
        nurse_expire_time: "00:05:00",
        awaiting_apt_time: "00:05:00"
      },
      passTimes: {
        white_passes_time: {
          isEditable: false,
          label: "Awaiting Approval (STU Passes)",
          color: "#fff"
        },
        min_time: {
          isEditable: false,
          label: "Long Running",
          color: "#f4e665"
        },
        auto_expire_time: {
          isEditable: false,
          label: "System Ended",
          color: "#DF3C3B"
        },
        nurse_expire_time: {
          isEditable: false,
          label: "Extended",
          color: "#672c91",
          textColor: "#fff"
        },
        awaiting_apt_time: {
          isEditable: false,
          label: "Awaiting Approval (APT Passes)",
          color: "#fff"
        }
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      passesTimeSetting: "passes/passesTimeSettings"
    })
  },
  mounted() {
    this.$store.dispatch("passes/getPassesTimeSetting").then((response) => {
      const data = response.data.data
      if (data && data.time_settings) {
        this.setFormData(data.time_settings)
      }
    })
  },
  methods: {
    submit() {
      this.resetResponseMessages()
      this.isLoading = true
      const params = {}
      for (const key in this.form) {
        if (Object.hasOwnProperty.call(this.form, key)) {
          const element = this.form[key]
          if (element) {
            params[key] = element
          }
        }
      }
      this.$store
        .dispatch("passes/setPassesTimeSetting", params)
        .then(() => {
          this.setSuccessResponse("Pass Time settings updated.")
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1500)
          this.isLoading = false
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    setFormData(data) {
      this.form = {
        white_passes_time: data.white_passes,
        min_time: data.min_time,
        auto_expire_time: data.auto_expire_time,
        nurse_expire_time: data.nurse_expire_time,
        awaiting_apt_time: data.awaiting_apt
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style>
.vue__time-picker input.display-time {
  height: auto !important;
}
</style>
